// UI hints only. Every mutation revalidates identity, scope and proof on the API.
export function readSensitiveActionPolicy(result) {
  const policy =
    result &&
    result.returncode === 1 &&
    result.returndata &&
    result.returndata.sensitive_action_policy;
  if (
    !policy ||
    typeof policy.mfa_required !== "boolean" ||
    typeof policy.can_perform !== "boolean" ||
    typeof policy.mfa_enabled !== "boolean" ||
    typeof policy.mfa_actor_name !== "string" ||
    !["owner", "super", "admin", "lucanet"].includes(policy.mfa_actor_role) ||
    (!policy.mfa_required && policy.mfa_actor_role !== "owner") ||
    (policy.mfa_required && policy.can_perform && !policy.mfa_enabled)
  ) {
    throw new Error("Sensitive action policy unavailable");
  }
  return policy;
}
